import React, { useRef, useEffect, useState } from 'react';
import * as R from 'ramda';
import $ from 'jquery';

import contriesList from 'iso-3166-1-alpha-2';
import { RegexFields } from '../../../../../../../../constants/utils/regexFields';
import OtherActivity from '../../../../../../../../constants/models/servicePayloads/otherActivity';
import {FrenchTypes} from '../../../../../../../../constants/utils/connectionTypes';
import ServiceData from '../../../../../../../../constants/models/serviceData';
import {ModalRetraiteSection} from './retraiteSection';

export const FormRetraite = ({ pensions, isLoading, userId, pensionDetails, setEditMode }) => {
	var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));

	const [pensionList, setPensionList] = useState([...pensions]);
	useEffect(() => {
		setPensionList([...pensions]);
	}, [pensions]);

	function removeFromList(index) {
		setPensionList(pensionList.filter((a) => a !== pensionList[index]));
	}

	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();
	}, []);
	return (
		<div className="card mx-sm mt-xs rounded">
			<div className="card-body scroll-default py-0">
				<article className="card" id="retraite">
					<h3 className="sr-only visually-hidden">Retraité</h3>

					{pensionList.map((pension, index) => {
						return <ModalRetraiteSection pension={pension} initCollapsedState={false} index={index} isLoading={isLoading} removeFromList={removeFromList} pensionDetails={pensionDetails} countries={countries} key={index} />;
					})}

					<footer className="block sticky-auto b-auto-0 z-2 mx-auto text-center pt-4 pb-1">
						<h4 className="sr-only visually-hidden">Ajouter une autre RETRAITE</h4>
						<button
							type="button"
							className="btn btn-icon btn-alert-info mx-auto py-2"
							onClick={(e) => {
								let serviceData = new ServiceData({
									userId: userId,
									serviceType: FrenchTypes.pension,
									serviceId: "pension" + pensionList.length,
									payload: {
										professionalCategory: null,
										pensionBaseServiceId: null,
										pensionComplementServiceId: null,
										customPensionBase: {
											name: null,
											address: {
												streetAddress: null,
												streetAddress2: null,
												streetAddress3: null,
												postalCode: null,
												addressLocality: null,
												addressCountry: null,
											},
											function: null,
										},
										customPensionComplement: {
											name: null,
											address: {
												streetAddress: null,
												streetAddress2: null,
												streetAddress3: null,
												postalCode: null,
												addressLocality: null,
												addressCountry: null,
											},
											function: null,
										},
									},
								});
								setPensionList([...pensionList, { ...serviceData, collapsed: true }]);
							}}>
							<i className="eva eva-person-add-outline h3 my-auto mr-2"></i>Ajouter une autre RETRAITE
						</button>
					</footer>
				</article>
			</div>
			<div className="card-footer">
				<button
					type="button"
					className="btn btn-light mr-2"
					onClick={(e) => {
						e.preventDefault();
						setPensionList([...pensions]);
						setEditMode(false);
					}}>
					Fermer
				</button>
			</div>
		</div>
	);
};